import React, { useEffect, useState } from "react";
import Breadcrumbs from "../components/Common/Breadcrumb";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Badge,
} from "reactstrap";

import DropdownWithTwoField from "../customComponents/DropdownWithTwoField";
import { useDispatch, useSelector } from "react-redux";

import CustomTable from "../customComponents/reactTable/CustomTable";
import { Link } from "react-router-dom";
import {
  getIndividualApplied,
  getIndividualJobRoles,
  getIndividualLocations,
  getJobsCount,
} from "./individualSlice";
import dayjs from "dayjs";
import DetailsCanvas from "../customComponents/offcanvas/CanvasJobdescription";
import CanvasInterview from "../customComponents/offcanvas/CanvasInterviewDetails";
import AdvanceFilter from "../customComponents/advance filter/AdvanceFilter";
import Preloader from "../components/Common/Preloader";
import { log_debug } from "../apiHelpers/logger";
import { Tags } from "../pages/Contacts/ContactList/contactlistCol";
import StatusBadge from "../customComponents/utilities/StatusBadge";
import moment from "moment";

function IndividualApplied() {
  const individualStore = useSelector((state) => state.individualSlice);
  const jobstatus = "applied";
  const [isOffcanvasOpen, setOffcanvasOpen] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const dispatch = useDispatch();
  const [appliedJob, setAppliedJob] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [JobRoleOptions, setJobRoleOptions] = useState([]);
  const [isPreloader, setisPreloader] = useState(true);
  const [TableLoading, setTableLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [RecordCount, setRecordCount] = useState(0);

  const [filtervalue, setFiltervalue] = useState("");
  const defaultStartDate = new Date();

  const defaultEndDate = new Date();
  const [formattedStartDate, setformattedStartDate] = useState(
    moment(defaultStartDate.setDate(defaultStartDate.getDate() - 90)).format(
      "YYYY-MM-DD",
    ),
  );
  const [formattedEndDate, setformattedEndDate] = useState(
    moment(defaultEndDate).format("YYYY-MM-DD"),
  );

  useEffect(() => {
    dispatch(
      getJobsCount({
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
      }),
    );
  }, []);

  const yourDynamicHeaderData = {
    title: "Title",
    location: "Location",
    createdAt: "Application Date",
    status: "Status",
  };

  const JobName = (job) => {
    // Do something with the selected candidate, e.g., fetch details
    setSelectedJob(job);
    setOffcanvasOpen(true);
  };

  const columns = [
    {
      Header: "Job Title",
      accessor: "title",
      Cell: ({ row }) => (
        <Link
          to={"#"}
          onClick={() => {
            JobName(row.original);
          }}
        >
          {row.values.title}
        </Link>
      ),
    },
    {
      Header: "Location",
      accessor: "location",
      Cell: ({ value }) => (value.length === 0 ? "-" : value.join(", ")),
    },
    {
      Header: "Required Skills",
      accessor: "skills",
      Cell: (cellProps) => {
        return <Tags {...cellProps} />;
      },
    },
    {
      Header: "Job Posted",
      accessor: "createdAt",
      Cell: (props) => {
        const tidyDate = dayjs(props.value).format("YYYY-MM-DD");
        return <span>{tidyDate}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",

      Cell: ({ value }) => (
        <StatusBadge status={value} />
        // <Badge
        //   color={
        //     value === "shortlisted" || value === "active"
        //       ? "success rounded-pill"
        //       : "warning rounded-pill"
        //   }
        //   className="m-1 font-size-12"
        // >
        //   {value}
        // </Badge>
      ),
    },

    // {
    //   Header: 'Discriptions',
    //   accessor: 'description',
    // },
    // Add more columns as needed
  ];

  const closeOffcanvas = () => {
    setOffcanvasOpen(false);
  };

  // useEffect(() => {
  //   dispatch(
  //     getIndividualApplied({
  //       jobstatus: jobstatus,
  //       limit: 100,
  //       offset: currentPage,
  //     }),
  //   );
  // }, []);

  // useEffect(() => {
  //   dispatch(
  //     getIndividualApplied({
  //       jobstatus: jobstatus,
  //       limit: 100,
  //       offset: currentPage,
  //       skills:"",
  //       locations:""
  //     }),
  //   );
  // }, []);

  useEffect(() => {
    if (individualStore.status === "idle") {
      if (individualStore.data.applieddata?.success === true) {
        setAppliedJob(individualStore.data.applieddata?.data?.jobDescriptions);
        setRecordCount(individualStore.data.applieddata?.data?.totalCount);
        setisPreloader(false);
        setTableLoading(false);
      }
      log_debug("applied job data", appliedJob);
    } else if (individualStore.status === "loading") {
      setTableLoading(true);
    }
  }, [individualStore.data.applieddata]);

  const [Location, setLocation] = useState([]);
  const [JobRole, setJobRole] = useState([]);

  const handleFilterChange = (option) => {
    if (option && option.location) {
      const locationLabels = option.location.map((location) => location.label);
      setLocation(locationLabels);
    }

    if (option && option.jobRole) {
      const jobRoleLabels = option.jobRole.map((jobRole) => jobRole.label);
      setJobRole(jobRoleLabels);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        getIndividualApplied({
          jobstatus: jobstatus,
          //limit: 100,
          offset: currentPage,
          skills: JobRole,
          locations: Location,
          filtervalue: filtervalue ? filtervalue : "",
        }),
      );
    }, 700);

    return () => clearTimeout(timer);
  }, [currentPage, Location, JobRole, filtervalue]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleValueChange = (newValue) => {
    setTableLoading(true);
    setFiltervalue(newValue);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Applied Jobs"
            Name="Applied Jobs"
          />
          {isPreloader && <Preloader status={true} />}
          <div className="col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <div>
                  {/* <Card
                    className=" pt-3"
                  > */}
                  <CardBody>
                    <Row>
                      <AdvanceFilter onFilterChange={handleFilterChange} />
                      <div className="col-12 col-lg-6 col-md-6">
                        <Col md={12}>
                          <CardTitle className="text-end fs-6 pt-3">
                            Total Jobs : {RecordCount}
                          </CardTitle>
                        </Col>
                      </div>
                    </Row>
                  </CardBody>
                  {/* </Card> */}
                </div>
                <div>
                  <Card className="">
                    <CardBody>
                      <CustomTable
                        tableDatas={appliedJob}
                        totalCount={RecordCount}
                        headerData={yourDynamicHeaderData}
                        columns={columns}
                        data={appliedJob}
                        hideCheckbox={true}
                        isLoading={TableLoading}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        ShowPagination={
                          appliedJob && appliedJob.length > 10 ? true : false
                        }
                        onChange={handleValueChange}
                        globalsearch={true}
                      />
                    </CardBody>
                  </Card>
                  {/* <DataTable title="All Jobs" columns={columns} data={jobs} /> */}
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      {isOffcanvasOpen && (
        <>
          <DetailsCanvas
            usertype="individual"
            menuOption="appliedjobs"
            width={60}
            isOpen={isOffcanvasOpen}
            toggle={() => setOffcanvasOpen(!isOffcanvasOpen)}
            onClose={closeOffcanvas}
            data={selectedJob}
          />

          {/* <CanvasInterview
          width={60}
          isOpen={isOffcanvasOpen}
          toggle={() => setOffcanvasOpen(!isOffcanvasOpen)}
          onClose={closeOffcanvas}
          /> */}
        </>
      )}
    </React.Fragment>
  );
}

export default IndividualApplied;
